// extracted by mini-css-extract-plugin
module.exports = {"signup":"Signup-module__signup___vibug","title":"Signup-module__title___2Hj4_","instructions":"Signup-module__instructions___pWtmf","button":"Signup-module__button___2b7Y_"};